import '../web-components/dialog-wrapper';
/**
 * generates and shows a dialog with the provided content as a modal (i.e. grey background and focus on dialog)
 */
export function showModal(content, options = {}) {
    return show('showModal', content, options);
}
export function showDialog(content, options = {}) {
    return show('showDialog', content, options);
}
export function showSimpleMessageModal(text) {
    const el = document.createElement('p');
    el.innerHTML = text;
    showModal(el, { classes: 'simple-message' });
}
function show(func, content, options = {}) {
    const _content = Array.isArray(content) ? content : [content];
    const wrapper = document.createElement('dialog-wrapper');
    const appendTo = options.appendTo || document.body;
    appendTo.append(wrapper);
    if (options.classes) {
        const _classes = Array.isArray(options.classes) ? options.classes : [options.classes];
        const dialogEl = wrapper.getDialogEl();
        dialogEl.classList.add(..._classes);
    }
    wrapper.setContent(..._content);
    wrapper[func]();
    return wrapper;
}
